import { render, staticRenderFns } from "./UpdatePassword.vue?vue&type=template&id=7539f402"
import script from "./UpdatePassword.vue?vue&type=script&lang=js"
export * from "./UpdatePassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7539f402')) {
      api.createRecord('7539f402', component.options)
    } else {
      api.reload('7539f402', component.options)
    }
    module.hot.accept("./UpdatePassword.vue?vue&type=template&id=7539f402", function () {
      api.rerender('7539f402', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/UpdatePassword.vue"
export default component.exports